module.exports = __webpack_public_path__ + "static/slide10_2.a03e6b18.png";